<template>
  <div class="profile-page">
    <div class="profile-card">
      <div class="profile-row">
        <span class="label">用户名</span>
        <span class="value">{{ userInfo.userName || '-' }}</span>
      </div>
      <div class="profile-row">
        <span class="label">用户ID</span>
        <span class="value">{{ userInfo.customerId || '-' }}</span>
      </div>
      <div class="profile-row">
        <span class="label">会员等级</span>
        <span class="value">{{ vipLevelText }}</span>
      </div>
      <div class="profile-row">
        <span class="label">姓名</span>
        <span class="value">{{ userInfo.trueName || '-' }}</span>
      </div>
      <div class="profile-row">
        <span class="label">手机号</span>
        <span class="value">{{ userInfo.mobile || '-' }}</span>
      </div>
      <div class="profile-row" v-if="isMinor">
        <span class="label">还可观看</span>
        <span class="value">{{ remainingTime }}</span>
      </div>
    </div>
    <div class="profile-actions">
      <div class="action-row" @click="showChangePassword = true">
        <span>修改密码</span>
        <span class="arrow">›</span>
      </div>
      <div class="action-row logout" @click="handleLogout">
        <span>退出登录</span>
        <span class="arrow">›</span>
      </div>
    </div>
    <Modal v-model="showChangePassword" title="修改密码" width="384" class-name="change-pwd-modal">
      <div class="pwd-form">
        <Input v-model.trim="newPassword" type="password" placeholder="请输入新密码" style="margin-bottom: 16px" />
        <Input v-model.trim="confirmPassword" type="password" placeholder="请确认新密码" style="margin-bottom: 16px" />
        <div class="sms-row">
          <Input v-model.trim="smsCode" placeholder="请输入验证码" style="flex: 1" />
          <Button type="primary" :disabled="countdown > 0" @click="sendSms" style="margin-left: 10px; min-width: 110px">
            {{ countdown > 0 ? countdown + 's后重发' : '获取验证码' }}
          </Button>
        </div>
      </div>
      <div slot="footer">
        <Button @click="closeChangePassword">取消</Button>
        <Button type="primary" @click="changePassword">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'

const api = axios.create({
  baseURL: 'https://c-api-test.vlebo.cn',
})

export default {
  name: 'Profile',
  data() {
    return {
      userInfo: {},
      showChangePassword: false,
      newPassword: '',
      confirmPassword: '',
      smsCode: '',
      countdown: 0,
    }
  },
  computed: {
    vipLevelText() {
      const levelMap = {
        0: '用户',
        1: '普通会员',
        2: '豪华会员',
      }
      return levelMap[this.userInfo.level] || '用户'
    },
    isMinor() {
      const idCard = this.userInfo.idCard
      if (!idCard || idCard.length < 14) return false
      const birthYear = parseInt(idCard.substring(6, 10))
      const birthMonth = parseInt(idCard.substring(10, 12))
      const birthDay = parseInt(idCard.substring(12, 14))
      const now = new Date()
      let age = now.getFullYear() - birthYear
      if (now.getMonth() + 1 < birthMonth || (now.getMonth() + 1 === birthMonth && now.getDate() < birthDay)) {
        age--
      }
      return age < 18
    },
    remainingTime() {
      const totalSeconds = 40 * 60
      const used = this.userInfo.viewDuration || 0
      const remaining = Math.max(totalSeconds - used, 0)
      const m = Math.floor(remaining / 60)
      const s = remaining % 60
      return m > 0 ? `${m}分钟${s > 0 ? s + '秒' : ''}` : `${s}秒`
    },
  },
  created() {
    this.loadUserInfo()
  },
  methods: {
    loadUserInfo() {
      const token = localStorage.getItem('token')
      if (!token) {
        this.$router.push('/index')
        return
      }
      api.get('/wen/get-info', {
        headers: { Authorization: token },
      }).then((res) => {
        const resData = res.data
        if (resData.code !== 200) return
        this.userInfo = resData.data
      })
    },
    handleLogout() {
      sessionStorage.removeItem('userinfo')
      localStorage.removeItem('token')
      sessionStorage.removeItem('teenagerMode')
      localStorage.removeItem('teenagerMode')
      localStorage.removeItem('supervisorPassword')
      this.$root.$emit('logout')
      this.$router.push('/index')
    },
    sendSms() {
      const mobile = this.userInfo.mobile
      if (!mobile) {
        this.$Message.warning('未获取到手机号')
        return
      }
      api.post('/customer/send-sms', { mobile }, {
        headers: { Authorization: localStorage.getItem('token') },
      }).then((res) => {
        const resData = res.data
        if (resData.code !== 200) {
          this.$Message.warning(resData.msg || '发送失败')
          return
        }
        this.$Message.success('验证码已发送')
        this.countdown = 60
        this.timer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            clearInterval(this.timer)
          }
        }, 1000)
      }).catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.msg) || '发送失败，请重试'
        this.$Message.warning(msg)
      })
    },
    closeChangePassword() {
      this.showChangePassword = false
      this.newPassword = ''
      this.confirmPassword = ''
      this.smsCode = ''
    },
    changePassword() {
      if (!this.newPassword) {
        this.$Message.warning('请输入新密码')
        return
      }
      if (this.newPassword !== this.confirmPassword) {
        this.$Message.warning('两次输入的密码不一致')
        return
      }
      if (!this.smsCode) {
        this.$Message.warning('请输入验证码')
        return
      }
      const token = localStorage.getItem('token')
      api.post('/wen/change-password', {
        mobile: this.userInfo.mobile,
        password: this.newPassword,
        code: Number(this.smsCode),
      }, {
        headers: { Authorization: token },
      }).then((res) => {
        const resData = res.data
        if (resData.code !== 200) {
          this.$Message.warning(resData.msg || '修改失败')
          return
        }
        this.$Message.success('密码修改成功，请重新登录')
        this.closeChangePassword()
        setTimeout(() => {
          this.handleLogout()
        }, 1500)
      }).catch((err) => {
        const msg = (err.response && err.response.data && err.response.data.msg) || '修改失败，请重试'
        this.$Message.warning(msg)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.profile-page {
  max-width: 500px;
  margin: 80px auto;
  padding: 0 16px;
}

.profile-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.profile-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  .label {
    color: #999;
    font-size: 14px;
    flex-shrink: 0;
  }

  .value {
    color: #333;
    font-size: 14px;
    text-align: right;
    word-break: break-all;
  }
}

.profile-actions {
  margin-top: 16px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.action-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  font-size: 14px;
  color: #333;

  &:last-child {
    border-bottom: none;
  }

  &:active {
    background: #f5f5f5;
  }

  .arrow {
    color: #ccc;
    font-size: 18px;
  }

  &.logout {
    color: #f56c6c;
  }
}

.pwd-form {
  padding: 8px 0;

  .sms-row {
    display: flex;
    align-items: center;
  }
}
</style>
